import React, {useEffect} from 'react'
import styled from 'styled-components'
import { Alert, Spinner } from 'react-bootstrap'
import useStores from '../../../stores/useStore'
import PickingPreparationSubheader from '../../../components/Withdrawals/PickingPreparation/PickingPreparationSubheader'
import PickingPreparationSidebar from '../../../components/Withdrawals/PickingPreparation/PickingPreparationSidebar'
import PickingPreparationContentArea from '../../../components/Withdrawals/PickingPreparation/PickingPreparationContentArea'
import { StyledGoodReceiptsContainer } from '../../../components/LocalReceipts/Form/formHelper'
import { useTranslation } from 'react-i18next'
import { ContentArea } from '../../../components/Page/logix2020/ContentArea'
import { TestSidebarRight } from '../../../components/Page/logix2020/TestSidebarRight'
import BigFooter from '../../../components/Footer/BigFooter'
import { FlexWrapper } from '../../../components/Page/logix2020/FlexWrapper'
import PickingPrepareDataProvider, { usePickingPrepareDataState } from '../../../stores/PickingPrepareDataProvider'
import { useParams } from 'react-router-dom'
import { Observer } from 'mobx-react'

const StyledContentArea = styled(ContentArea)`
   padding: 20px 40px 20px 36px;
   @media (max-width: 1080px) {
    padding: 20px;
    min-height: calc(100vh - 488px);//header+navbar+sidebar=488px
   }
   .added-row {
    label {
      display: block;
    }
  }
`
const PickingPreparationPageContent = () => {
    const { soId } = useParams()
    const { loadOrderData } = usePickingPrepareDataState()
    
    useEffect(() => {
      const init = async () => {
        loadOrderData(soId)
      }
      init()
    }, [soId, loadOrderData])
  
    return (
        <>
        <PickingPreparationSubheader />
        <FlexWrapper>
          <StyledContentArea>
            <PickingPreparationContentArea />
          </StyledContentArea>
          <TestSidebarRight>
            <PickingPreparationSidebar />
          </TestSidebarRight>
        </FlexWrapper>
        <BigFooter />
      </>
    )
  }
  
  const PickingPreparationPage = () => {
    const { uiStore } = useStores()
    const { t } = useTranslation()
    return (<Observer>{() => (
      <PickingPrepareDataProvider>
        <StyledGoodReceiptsContainer>
          {!uiStore.dashboard || !uiStore.allowPickingProcess
            ? (
              <FlexWrapper>
                <StyledContentArea>
                  {!!uiStore.dashboard
                    ? <Alert variant="danger">{t('withdrawalPage:accessDenied')}</Alert>
                    : <div className="d-flex align-items-center justify-content-center">< Spinner animation='border' variant='primary' /></div >
                  }
                </StyledContentArea>
                <TestSidebarRight>
                </TestSidebarRight>
              </FlexWrapper>)
            :
            <PickingPreparationPageContent />
          }
          <BigFooter />
        </StyledGoodReceiptsContainer>
      </PickingPrepareDataProvider>
    )}</Observer>)
  }
  
  export default PickingPreparationPage
  